( function ( _s ) {
	_s( document ).ready( () => {
		/** Bootstrap .container width */
		const containerWidth = () => {
			const maxWidth = _s( '.fr-content-row > .container' ).outerWidth() ?? 0;
			window.setRootProperty(
				'--bootstrap-container-width',
				maxWidth ? maxWidth + 'px' : '100%'
			);
		};

		containerWidth();

		_s( window ).on( 'resize', () => {
			containerWidth();
		} );
	} );
} )( window._s );
